import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class GalleryService {

  static getGallery(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getGallery}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getGallery}?limit=${item?.limit}&page=${item?.page}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addGallery(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addGallery}`;
    return axiosInstance
        .post(api,item)
        
}
static editGallery(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editGallery}`;
    return axiosInstance
        .put(api,item)
        
}
static deleteGallery(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deleteGallery}?id=${item?.id}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default GalleryService;